import Dexie from "dexie";

const dbName = "CenterChatDB";
//@ts-ignore
let db: Dexie = null;
export function getChatDB(): Dexie {
  if (!db) {
    db = new Dexie(dbName);
  }
  console.log("[getChatDB]");
  //@ts-ignore
  if (db._storeNames.length < 1) {
    db.version(20).stores({
      chat_message: "id, data",
      chat_message_images: "id, imageData",
      chat_message_sticker: "id, stickerData",
      chat_sticker_info: "id, data",
    });
    db.on("versionchange", () => {
      console.log("version change");
    });
    db.open().catch(function (e) {
      console.error("Open CenterChatDB failed: ", e);
    });
  }
  return db;
}

export async function deleteChatDB() {
  try {
    console.log("Deleting CHATDB...");
    await Dexie.delete(dbName);
  } catch (e) {
    console.error("[DeleteChatDB]", e);
  }
}
